export { default } from './CLStyledTable';
